import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var RecoverfinishedComponent = (function () {
    function RecoverfinishedComponent(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
        this.destroy$ = new Subject();
    }
    RecoverfinishedComponent.prototype.ngOnInit = function () { };
    RecoverfinishedComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Recover finished turn */
    RecoverfinishedComponent.prototype.recoverFinished = function () {
        var _this = this;
        var params = {
            turn_id: this._data.selectedTurn["id"],
            desk_id: this._data.selectedTurn["desk_id"],
            fromqueue: 0,
            toqueue: 0,
            kind_id: 0,
            position: 'S'
        };
        this._blogic.moveTurn(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
        });
    };
    return RecoverfinishedComponent;
}());
export { RecoverfinishedComponent };
